module.exports = __webpack_public_path__ + "static/media/sidebar-3.b8a3fd46.jpg";